import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import { formatMessage } from '../../lib/intl';

import Dropdown from '../dropdown';
import './../../css/payment-source-fields.css';

const i18n = defineMessages({
  paymentSourceDescription: {
    id: 'paymentSourceSelector.selectorOptions.description',
    defaultMessage: 'that ends {lastFour} (exp: {validUntil})',
  },
  addNew: {
    id: 'paymentSourceSelector.selectorOptions.addNew',
    defaultMessage: 'Add new method',
  },
  addNewButton: {
    id: 'paymentSourceSelector.addNewButton',
    defaultMessage: 'Add new',
  },
  or: {
    id: 'paymentSourceSelector.or',
    defaultMessage: 'or',
  },
})

export class PaymentSourceSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addNewSelected: props.paymentSources.length === 0,
    };
    this.onPaymentSourceSelected = this.onPaymentSourceSelected.bind(this);
    this.onAddNewCard = this.onAddNewCard.bind(this);
    this.formatMessage = formatMessage(this.props.intl);
  }

  onPaymentSourceSelected({ target: { value } }) {
    this.setState({ addNewSelected: value === 'new' });
    this.props.onChange(value);
  }

  onAddNewCard() {
    this.onPaymentSourceSelected({ target: { value: 'new' } });
  }

  get validPaymentSources() {
    return this.props.paymentSources;
  }

  isValidDate(dateString) {
    const [month, year] = dateString.split('/');
    const today = new Date();
    const cardDate = new Date();
    cardDate.setFullYear(parseInt('20' + year, 10), parseInt(month, 10), 1);
    return cardDate < today;
  }

  addNewSelected() {
    return this.state.addNewSelected;
  }

  buildPaymentSourcesOptions() {
    const opts = this.validPaymentSources
      .map((paymentSource) => {
        const name = this.formatMessage(i18n.paymentSourceDescription, { ...paymentSource.info });
        return {
          value: paymentSource.id,
          text: name,
          className: paymentSource.info.cardType,
        };
      });

    return [...opts, {
      value: 'new',
      text: this.formatMessage(i18n.addNew),
      className: 'new',
    }];
  }

  renderAddNewButton() {
    if (this.addNewSelected()) return null;

    return (
      <div className="col-sm-4">
        <span className="text-separator">
          {this.formatMessage(i18n.or)}
        </span>
        <button
          type="button"
          onClick={this.onAddNewCard}
          className="btn btn-secondary add-new-button"
        >
          {this.formatMessage(i18n.addNewButton)}
        </button>
      </div>
    );
  }

  render() {
    return (
      <div className="row">
        <div className="col-sm-8">
          <Field
            name="paymentSourceId"
            className="payment-source-selector"
            component={Dropdown}
            options={this.buildPaymentSourcesOptions()}
            onChange={this.onPaymentSourceSelected}
            noGroup
          />
        </div>
        {this.renderAddNewButton()}
      </div>
    );
  }
}

PaymentSourceSelector.defaultProps = {
  onChange: () => { },
  paymentSources: [],
  validCardTypes: [],
};

export default injectIntl(PaymentSourceSelector);



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/payment-source-selector.js